import React from 'react';

const MarqueeServices2 = () => {
  // Service list
  const services = [
    'Veriye Dayalı Influencer Seçimi',
    'Influencer İletişimi',
    'İçerik fikri, Taslak ve Storyboard',
    'Çekim Planlaması',
    'Briefing',
    'Revize ve Kurgu Süreçleri',
    'Yayın Takvimi ve Takip',
    'Sözleşme ve Ödeme Süreçleri',
    'Performans Raporları',
    'Kampanya Yönetimi',
    'İletişim ve İçerik Stratejileri',
    'Sosyal Medya Pazarlama'
  ];

  // Single service item with middle dot separator
  const ServiceItem = ({ service, isFirst }) => (
    <div className="flex items-center flex-shrink-0">
      {!isFirst && (
        <span 
          className="mx-3 md:mx-5 text-sm md:text-base"
          style={{ color: 'rgba(0,0,0,0.3)' }}
        >
          ·
        </span>
      )}
      <span 
        className="text-sm md:text-base font-bold whitespace-nowrap"
        style={{ color: 'rgba(0,0,0,0.7)', letterSpacing: '1px' }}
      >
        {service}
      </span>
    </div>
  );

  return (
    <div className="bg-[#FFDD59] overflow-hidden border-t-2 border-b-2 border-black/20">
      {/* Marquee - Right to Left */}
      <div className="py-3 md:py-4 overflow-hidden">
        <div 
          className="flex items-center"
          style={{
            animation: 'scroll2 30s linear infinite',
            width: 'max-content'
          }}
        >
          {/* First set */}
          {services.map((service, i) => <ServiceItem key={`a-${i}`} service={service} isFirst={i === 0} />)}
          <span className="mx-3 md:mx-5 text-sm md:text-base" style={{ color: 'rgba(0,0,0,0.3)' }}>·</span>
          {/* Second set for seamless loop */}
          {services.map((service, i) => <ServiceItem key={`b-${i}`} service={service} isFirst={i === 0} />)}
          <span className="mx-3 md:mx-5 text-sm md:text-base" style={{ color: 'rgba(0,0,0,0.3)' }}>·</span>
        </div>
      </div>

      {/* Mobile second row - reverse direction */}
      <div className="py-3 md:hidden border-t border-black/10 overflow-hidden">
        <div 
          className="flex items-center"
          style={{
            animation: 'scroll2-reverse 30s linear infinite',
            width: 'max-content'
          }}
        >
          {services.map((service, i) => <ServiceItem key={`c-${i}`} service={service} isFirst={i === 0} />)}
          <span className="mx-3 md:mx-5 text-sm md:text-base" style={{ color: 'rgba(0,0,0,0.3)' }}>·</span>
          {services.map((service, i) => <ServiceItem key={`d-${i}`} service={service} isFirst={i === 0} />)}
          <span className="mx-3 md:mx-5 text-sm md:text-base" style={{ color: 'rgba(0,0,0,0.3)' }}>·</span>
        </div>
      </div>

      <style>{`
        @keyframes scroll2 {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes scroll2-reverse {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
      `}</style>
    </div>
  );
};

export default MarqueeServices2;
